import React from'react';var Detail=function Detail(props){return React.createElement(React.Fragment,null);};export default Detail;